import { ViewingService } from "./Xhr";

export class DtHttpError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
    this.ctx = null;
  }

  setErrorCtx(ctx) {
    this.ctx = ctx;
  }
}

export function fetchJsonAndETag(loadContext, url, method = 'GET', body = null, headers = null) {
  return new Promise((resolve, reject) => {
    ViewingService.getItem(
      loadContext,
      loadContext.endpoint + url,
      (data, headers, status) => resolve({ data, etag: headers.etag, status }),
      (status) => reject(new DtHttpError(`Request to ${loadContext.endpoint + url} failed (status: ${status})`, status)),
      {
        responseType: "json",
        method,
        postData: body ? JSON.stringify(body) : null,
        headers,
        responseHeaders: ['etag']
      }
    );
  });
}


export function fetchJson(loadContext, url, method = 'GET', body = null, headers = null, useV2 = false) {
  let postData = null;
  if (body) {
    postData = ArrayBuffer.isView(body) ? body : JSON.stringify(body);
  }

  let endpoint = loadContext.endpoint;
  if (useV2) {
    endpoint = loadContext.endpoint.replace("v1", "v2");
  }

  return new Promise((resolve, reject) => {
    ViewingService.getItem(
      loadContext,
      endpoint + url,
      resolve,
      (status) => reject(new DtHttpError(`Request to ${endpoint + url} failed (status: ${status})`, status)),
      {
        responseType: "json",
        method,
        postData: postData,
        headers
      }
    );
  });
}

export function fetchFile(loadContext, url, method = 'GET', file) {
  return new Promise((resolve, reject) => {
    ViewingService.getItem(
      loadContext,
      loadContext.endpoint + url,
      resolve,
      reject,
      {
        method,
        postData: file
      }
    );
  });
}